import { render, staticRenderFns } from "./AskueTabContent.vue?vue&type=template&id=cfa3cd00&"
import script from "./AskueTabContent.vue?vue&type=script&lang=ts&"
export * from "./AskueTabContent.vue?vue&type=script&lang=ts&"
import style0 from "./AskueTabContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VCol,VImg,VTooltip})
